import {IFormController, ILogService} from 'angular';
import {Set} from 'immutable';
import * as moment from 'moment';
import IOrganizationApi from '../../api/organization-api.service';

import {IStation} from '../../api/api.types';

export interface IBulletinStateParams {
  type: string
}

export class BulletinController {
  static readonly $inject = ['organizationApi', '$log', '$stateParams', '$timeout'];

  /**
   * Form for the overridenDate control.
   */
  bulletinForm: IFormController;
  /**
   * Bulletin overridenDate.
   */
  date: Date;
  /**
   * Selected stations.
   */
  selectedStations: Set<IStation>;
  /**
   * Whether a loading operation is in progress.
   */
  loadingInProgress: boolean;
  /**
   * URL of the produced bulletin.
   */
  readyToDownload: boolean;
  /**
   * Maximum allowed overridenDate.
   */
  readonly maxDate: Date;

  bulletinType: string;

  subscriber: string;
  subscriberList: string[] = [];
  decadalPeriod: number[] = _.range(1, 10);
  decadalBulletinIssueDate: number;

  preselectedStations: IStation[] = [];

  constructor(private organizationApi: IOrganizationApi, private $log: ILogService, private $stateParams: IBulletinStateParams,
              private $timeout: ng.ITimeoutService) {
    this.date = new Date();
    this.selectedStations = Set<IStation>();
    this.loadingInProgress = false;
    this.maxDate = new Date();
    this.readyToDownload = false;

    this.bulletinType = this.$stateParams.type;

    if (this.bulletinType === "decadal") {
      this.organizationApi.getDecadalBulletinSettings()
        .then(data => {
          this.decadalBulletinIssueDate = data.dayOfDecade;
          this.subscriberList = data.subscriptions;
          this.preselectedStations = data.sites;
        })
    }
  }

  onSelectedStationsChange(selectedStations: Set<IStation>) {
    this.selectedStations = selectedStations;
    if (selectedStations) {
      this.preselectedStations = selectedStations.toArray();  
    }
  }

  prepareBulletin() {
    this.loadingInProgress = true;
    this.$timeout(() => {
        this.readyToDownload = true;
    }, 1000).finally(() => {
          this.loadingInProgress = false;
    });
  }

  downloadBulletin() {
    this.loadingInProgress = true;
    this.organizationApi.generateBulletin(
        this.$stateParams.type === 'daily' ? 'daily_bulletin' : 'decadal_bulletin',
        this.selectedStations.map(station => station.id).toArray(),
        moment(this.date))
        .then((data) => {
            const byteArray = new Uint8Array(data.filecontent);
            const filename = data.filename;
            var blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            // Create a link element and click it to trigger the download
            var downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(blob);
            downloadLink.download = filename;
            downloadLink.click();
        })
        .catch(error => {
          this.$log.error('Error retrieving bulletin.', error);
        })
        .finally(() => {
          this.loadingInProgress = false;
        });
  }

  addToSubscriberList(subscriber: string) {
    this.subscriberList.push(subscriber);
  }

  removeSubscriber($index: number) {
    this.subscriberList.splice($index, 1);
  }

  onDecadalBulletinScheduleSettingsSave() {
    this.loadingInProgress = true;
    this.organizationApi.saveDecadalBulletinSettings({
      dayOfDecade: this.decadalBulletinIssueDate,
      subscriptions: this.subscriberList,
      siteIds: this.selectedStations.map(station => station.id).toArray()
    })
    .finally(() => {
      this.loadingInProgress = false;
    })
    
  }

  onDecadalBulletinScheduleSettingsDelete() {
    this.loadingInProgress = true;
    this.organizationApi.deleteDecadalBulletinSettings()
    .then(() => {
      this.decadalBulletinIssueDate = null;
      this.subscriberList = [];
    })
    .finally(() => {
      this.loadingInProgress = false;
    })
  }

  isDecadalBulletinScheduleSettingsSaveDisabled() {
    return typeof this.decadalBulletinIssueDate === 'undefined' ||
           !(this.subscriberList && this.subscriberList.length) ||
           !(this.selectedStations && this.selectedStations.toArray().length)
  }
}



/** WEBPACK FOOTER **
 ** ./app/operational/bulletin/bulettin.controller.ts
 **/